import { LucideProps } from 'lucide-react';

export const Facebook = (props: LucideProps) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5889_38862)">
      <path
        d="M24.9473 12C24.9473 5.37258 19.5747 0 12.9473 0C6.31984 0 0.947266 5.37258 0.947266 12C0.947266 17.9895 5.33547 22.954 11.0723 23.8542V15.4688H8.02539V12H11.0723V9.35625C11.0723 6.34875 12.8638 4.6875 15.6048 4.6875C16.9173 4.6875 18.291 4.92188 18.291 4.92188V7.875H16.7779C15.2873 7.875 14.8223 8.80008 14.8223 9.75V12H18.1504L17.6184 15.4688H14.8223V23.8542C20.5591 22.954 24.9473 17.9895 24.9473 12Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5889_38862">
        <rect width="24" height="24" fill="white" transform="translate(0.947266)" />
      </clipPath>
    </defs>
  </svg>
);
